import { MprcFeedTypography } from "components/MprcFeedTypography";
import { useTranslation } from "react-i18next";

///
export const ThreadItemClassification = () => {

    const { t } = useTranslation("knowledge");

    return (
        <MprcFeedTypography variant="classification">
            <span>{t("Feed.Card.Common.TheadClassificationText")}</span>
        </MprcFeedTypography>
    );
};
